/** import package [start] */
import React from "react";
import { Modal as BootstrapModal } from "react-bootstrap";
import { ImCross } from "react-icons/im";
/**
 * modal component
 * @param param0 props
 * @returns
 */
const Modal = ({ onHide, show, title, titleClassName = "text-center", titleIcon, size, bodyClassName, modalClassName, children, visibleCloseButton = false, backdrop = undefined }) => {
    return (React.createElement(BootstrapModal, { onHide: onHide, show: show, size: size, "aria-labelledby": "contained-modal-title-vcenter", centered: true, backdrop: backdrop, className: modalClassName },
        React.createElement(BootstrapModal.Body, { className: bodyClassName },
            visibleCloseButton ? (React.createElement("div", { className: `d-flex align-items-center justify-content-between ${titleClassName}` },
                typeof title === "object" && title,
                typeof title === "string" && React.createElement("h5", { className: "mb-0" }, title),
                React.createElement(ImCross, { className: "text-muted cursor-clickable", onClick: onHide }))) : (React.createElement("div", { className: `${titleClassName}` },
                React.createElement("h5", { className: "mb-0" },
                    typeof titleIcon === "object" && titleIcon,
                    typeof titleIcon === "string" && (React.createElement("img", { src: titleIcon, alt: "title-icon", className: "" })),
                    title))),
            children)));
};
export default Modal;
